import { isNewItemOfDropdownSelection } from '@commons/utils/format';
import mixpanelUtils, { ENUM_EVENTS } from '@commons/utils/mixpanel';

/**
 * Inventory list templates typed on the fly in a dropdown are created by the back when the form is saved
 */
export const sendInventoryListTemplatesCreatedOnTheFlyMetrics = (
  inventoryListTemplates = [],
  source,
) => {
  inventoryListTemplates.filter(isNewItemOfDropdownSelection).forEach(() => {
    mixpanelUtils.sendMetric(ENUM_EVENTS.CREATE_INVENTORY_TEMPLATE, { source });
  });
};
